import { PDFViewer } from "@react-pdf/renderer"
import { useSelector } from "react-redux";
import TasimaSenediShipmentPDF from "../pdf/TasimaSenediShipmentPDF";
import { useEffect, useState } from "react";

const ShipmentPDFViewer = () => {

    const { shipmentData } = useSelector(state => state.loadList);
    const {topBarCompanyInfo } = useSelector(state => state.companyProfile)
    
    const [data, setData] = useState(null)

    
    useEffect(() => {
        if(topBarCompanyInfo?.companyName && topBarCompanyInfo?.yetkiliPhoneNumber){
            setData({
                ...shipmentData,
                companyShortName: topBarCompanyInfo?.companyShortName || topBarCompanyInfo?.companyName,
                yetkiliPhoneNumber: topBarCompanyInfo?.yetkiliPhoneNumber
            })
        }
    },[topBarCompanyInfo?.companyShortName, topBarCompanyInfo?.companyName, topBarCompanyInfo?.yetkiliPhoneNumber])

  return (
    <div>
      {
        data &&
          <PDFViewer width="100%" height="500px">
              <TasimaSenediShipmentPDF data={data} />
          </PDFViewer>
        }
    </div>
  )
}

export default ShipmentPDFViewer